import { API_ENDPOINTS } from "@/api/services/pms/apiEndPoints";
import { baseApi } from "@/utils/baseApi";
import { EmployeeApi } from "../Employee/employeeApi";
import { DivisionHeadApi } from "../DivisionHead/divisionHeadApi";

export const AsHRApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAsHRDropdown: builder.query({
      query: ({
        pmsYear,
        divHeadId,
        reviewerId,
        repManId,
        roleOfIntake,
        status,
        promotion,
      }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.ASHR_DROPDOWN(pmsYear, divHeadId, reviewerId, repManId, roleOfIntake, status, promotion)}`,
          method: "GET",
        };
      },
      providesTags: ["asHR_dropdown"],
    }),
    getManpowerDropdown: builder.query({
      query: ({ pmsYear }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.MANPOWER_DROPDOWN(pmsYear)}`,
          method: "GET",
        };
      },
      providesTags: ["manpower_dropdown"],
    }),
    getSampleDownload: builder.query({
      query: ({ pmsYear, levelName }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.ASHR_SAMPLEDOWNLOAD(pmsYear, levelName)}`,
          method: "GET",
          responseHandler: async (response) => {
            if (!response.ok) {
              const errorData = await response.json();
              return errorData;
            }
            return response.blob();
          },
        };
      },
      providesTags: ["asHR_sampleDownload"],
    }),
    asHRBulkUpload: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.ASHR.ASHR_BULKUPLOAD,
        method: "PUT",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["asHR_list", "hr_summary"],
    }),
    manpowerBulkUpload: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.ASHR.MANPOWER_BULKUPLOAD,
        method: "POST",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["manpower_list"],
    }),
    getManpowerList: builder.query({
      query: ({ empId, pmsYear }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.MANPOWER_LIST(empId, pmsYear)}`,
          method: "GET",
        };
      },
      providesTags: ["manpower_list"],
    }),
    getAsHRList: builder.query({
      query: ({
        level,
        repManId,
        reviewerId,
        divHeadId,
        empId,
        manPower,
        pmsYear,
        roleOfIntake,
        department,
        grade,
        pageNo,
        pageSize,
        status,
        promotion,
        qcStatus,
      }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.ASHR_LIST(
            level,
            repManId,
            reviewerId,
            divHeadId,
            empId,
            manPower,
            pmsYear,
            roleOfIntake,
            department,
            grade,
            pageNo,
            pageSize,
            status,
            promotion,
            qcStatus,
          )}`,
          method: "GET",
        };
      },
      providesTags: ["asHR_list"],
    }),
    updateAsHR: builder.mutation({
      query: (data) => {
        const { checkPromotionWeightage = 0, ...body } = data;
        return {
          url: `${API_ENDPOINTS.ASHR.ASHR_UPDATE(checkPromotionWeightage)}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: [
        "asHR_list",
        // "DH_Budget",
        // "pms_list",
        "pms_analytics_chart",
        "bh_chart",
        "emp_history",
        "pms_count",
        "HR_StatusCount",
      ],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(EmployeeApi.util.invalidateTags(["pms_list", "DH_Budget"]));
        } catch (error) {
          // console.error("withdrawRegularization failed:", error);
        }
      },
    }),

    ctcBulkUpload: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.ASHR.BULK_UPLOAD,
        method: "POST",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["revisedCTC_list"],
    }),

    ctcDownloadSampleFile: builder.mutation({
      query: () => ({
        url: API_ENDPOINTS.ASHR.CTC_SAMPLE_DOWNLOAD,
        method: "GET",
        responseHandler: async (response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return await response.blob();
        },
      }),
    }),

    getCtcBreakupList: builder.query({
      query: ({ level, pmsYear, page, pageSize }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.CTC_BREAKUP(
            level,
            pmsYear,
            page,
            pageSize,
          )}`,
          method: "GET",
        };
      },
      providesTags: ["Ctcbreakup_list"],
    }),
    getPayrollList: builder.query({
      query: ({
        level,
        repManId,
        reviewerId,
        divHeadId,
        empId,
        manPower,
        pmsYear,
        roleOfIntake,
        department,
        grade,
        page,
        size,
      }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.CTC_LIST(
            level,
            repManId,
            reviewerId,
            divHeadId,
            empId,
            manPower,
            pmsYear,
            roleOfIntake,
            department,
            grade,
            page,
            size,
          )}`,
          method: "GET",
        };
      },
      providesTags: ["payroll_list"],
    }),

    getCtcDropDown: builder.query({
      query: () => {
        return {
          url: `${API_ENDPOINTS.ASHR.CTC_DROPDOWN()}`,
          method: "GET",
        };
      },
      providesTags: ["Ctcbreakup_list"],
    }),

    getCtcExport: builder.query({
      query: ({ pmsYear }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.CTC_EXPORT(pmsYear)}`,
          method: "GET",
          responseHandler: (response) => response.blob(),
        };
      },
      providesTags: ["Ctc_Export"],
    }),
    getOrgList: builder.query({
      query: ({
        level,
        pmsYear,
        divisionHeadId,
        reviewerId,
        repManagerId,
        empId,
        department,
        roleOfIntake,
        grade,
        mailStatus,
        manualMailStatus,
        promotionType,
        manPower,
        pageNo,
        pageSize,
      }) => {
        return {
          url: `${API_ENDPOINTS.ORG.ORG_LIST(
            level,
            pmsYear,
            divisionHeadId,
            reviewerId,
            repManagerId,
            empId,
            department,
            roleOfIntake,
            grade,
            mailStatus,
            manualMailStatus,
            promotionType,
            manPower,
            pageNo,
            pageSize,
          )}`,
          method: "GET",
        };
      },
      providesTags: ["ORG_list"],
    }),
    sendOrgMail: builder.mutation({
      query: (data) => {
        return {
          url: `${API_ENDPOINTS.ORG.ORG_MAIL_SEND()}`,
          method: "PUT",
          body: data,
          responseHandler: (response) => response.blob(),
        };
      },
      invalidatesTags: ["ORG_list", "org_count"],
    }),
    sendManualMail: builder.mutation({
      query: (data) => {
        return {
          url: `${API_ENDPOINTS.ORG.ORG_MANUAL_MAIL_SEND()}`,
          method: "POST",
          body: data,
          responseHandler: (response) => response.blob(),
        };
      },
      invalidatesTags: ["ORG_list", "org_count"],
    }),
    getORGLetterPreview: builder.query({
      query: ({ pmsYear, empId }) => {
        return {
          url: `${API_ENDPOINTS.ORG.ORG_LETTER_PREVIEW(pmsYear, empId)}`,
          method: "GET",
          responseHandler: (response) => response.blob(),
        };
      },
      providesTags: ["ORG_LETTER"],
    }),
    getOrgCount: builder.query({
      query: ({
        level,
        pmsYear,
        divisionHeadId,
        reviewerId,
        repManagerId,
        // empId,
        // department,
        roleOfIntake,
        grade,
        // mailStatus,
        manualMailStatus,
        promotionType,
        manPower,
      }) => {
        const body = Object.fromEntries(
          Object.entries({
            level,
            pmsYear,
            divisionHeadId,
            reviewerId,
            repManagerId,
            // empId,
            // department,
            roleOfIntake,
            grade,
            // mailStatus,
            manualMailStatus,
            promotionType,
            manPower,
          }).filter(
            ([_, value]) =>
              value !== undefined && value !== null && value !== "",
          ),
        );

        return {
          url: API_ENDPOINTS.ORG.ORG_COUNT(),
          method: "POST",
          body,
        };
      },
      providesTags: ["org_count"],
    }),

    orgManualUpload: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.ORG.ORG_MANUAL_UPLOAD(),
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["ORG_list"],
    }),

    getOrgpending: builder.query({
      query: () => {
        return {
          url: `${API_ENDPOINTS.ORG.ORG_PEDNING_COUNT()}`,
          method: "GET",
        };
      },
      providesTags: ["org_dropdown"],
    }),

    getDhAnalyticsReport: builder.query({
      query: ({ level, pmsYear, divHeadId, reviewerId, repManId, grade }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.DH_ANALYTICS_REPORT(
            level,
            pmsYear,
            divHeadId,
            reviewerId,
            repManId,
            grade,
          )}`,
          method: "GET",
        };
      },
      providesTags: ["dh_Analytics_report"],
    }),
    getAnalyticsReport: builder.query({
      query: ({ pmsYear, divHeadId, reviewerId, repManId, grade }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.FETCH_ANALYTICS_REPORT(
            pmsYear,
            divHeadId,
            reviewerId,
            repManId,
            grade,
          )}`,
          method: "GET",
        };
      },
      providesTags: ["Analytics_report"],
    }),
    ltipDownloadSampleFile: builder.mutation({
      query: () => ({
        url: API_ENDPOINTS.LTIP.LTIP_SAMPLE_DOWNLOAD,
        method: "GET",
        responseHandler: async (response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return await response.blob();
        },
      }),
    }),
    getQcList: builder.query({
      query: ({
        level,
        pmsYear,
        divHeadId,
        reviewerId,
        repManId,
        empId,
        department,
        roleOfIntake,
        grade,
        manPower,
        qcStatus,
        pageNo,
        pageSize,
      }) => {
        return {
          url: `${API_ENDPOINTS.QC.QC_LIST(
            level,
            pmsYear,
            divHeadId,
            reviewerId,
            repManId,
            empId,
            department,
            roleOfIntake,
            grade,
            manPower,
            qcStatus,
            pageNo,
            pageSize,
          )}`,
          method: "POST",
        };
      },
      providesTags: ["QC_list"],
    }),

    getQCLetterPreview: builder.query({
      query: ({ pmsYear, empId }) => {
        return {
          url: `${API_ENDPOINTS.QC.QC_LETTER_PREVIEW(pmsYear, empId)}`,
          method: "GET",
          responseHandler: (response) => response.blob(),
        };
      },
      providesTags: ["QC_LETTER"],
    }),
    QCupdate: builder.mutation({
      query: (data) => {
        return {
          url: API_ENDPOINTS.QC.QC_UPDATE,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["QC_list", "asHR_list"],
    }),

    qcDownloadSampleFile: builder.mutation({
      query: (pmsYear) => ({
        url: API_ENDPOINTS.QC.QC_SAMPLE_DOWNLOAD,
        method: "POST",
        body: { pmsYear },
        responseHandler: async (response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return await response.blob();
        },
      }),
    }),

    qcBulkUpload: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.QC.QC_BULK_UPLOAD,
        method: "PUT",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["QC_list"],
    }),

    ocrBulkUpload: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.OCR.OCR_BULK_UPLOAD,
        method: "PUT",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["ocr_list"],
    }),

    ocrUpdate: builder.mutation({
      query: (data) => ({
        url: API_ENDPOINTS.OCR.OCR_UPDATE,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ocr_list"],
    }),

    qcOcrCompare: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.QC.QC_OCR_COMPARE,
        method: "POST",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
    }),

    qcUpdateLetterStatus: builder.mutation({
      query: ({ pmsYear, empId }) => ({
        url: API_ENDPOINTS.QC.QC_UPDATE_LETTER_STATUS(pmsYear, empId),
        method: "PUT",
      }),
      invalidatesTags: ["QC_list"],
    }),

    getLtipList: builder.query({
      query: ({
        pmsYear,
        year,
        divHeadId,
        reviewerId,
        repManId,
        empId,
        manPower,
        mailstatus,
      }) => {
        const body = {};
        if (pmsYear) body.pmsYear = pmsYear;
        if (year) body.year = year;
        if (divHeadId) body.divisionHeadId = divHeadId;
        if (reviewerId) body.reviewerId = reviewerId;
        if (repManId) body.repManagerId = repManId;
        if (empId) body.empId = empId;
        if (manPower) body.manPower = manPower;
        if (mailstatus) body.ltipMailStatus = mailstatus;

        return {
          url: API_ENDPOINTS.LTIP.LTIP_LIST,
          method: "POST",
          body,
        };
      },
      providesTags: ["Ltip_list"],
    }),
    getLtipLetterPreview: builder.query({
      query: ({ pmsYear, empId }) => {
        return {
          url: `${API_ENDPOINTS.LTIP.LTIP_LETTER_PREVIEW(pmsYear, empId)}`,
          method: "GET",
          responseHandler: (response) => response.blob(),
        };
      },
      providesTags: ["LTIP_LETTER"],
    }),

    ltipBulkUpload: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.LTIP.LTIP_BULK_UPLOAD,
        method: "POST",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      invalidatesTags: ["Ltip_list"],
    }),

    Ltipupdate: builder.mutation({
      query: (data) => {
        return {
          url: API_ENDPOINTS.LTIP.LTIP_UPDATE,
          method: "PUT",
          body: data,
          responseHandler: async (response) => {
            if (!response.ok) {
              const errorData = await response.json();
              throw errorData;
            }
            return await response.blob();
          },
        };
      },
      invalidatesTags: ["Ltip_list"],
    }),

    getLtipDropdown: builder.query({
      query: ({ divHeadId, reviewerId, repManId }) => {
        return {
          url: `${API_ENDPOINTS.LTIP.LTIP_DROPDOWN(divHeadId, reviewerId, repManId)}`,
          method: "GET",
        };
      },
      providesTags: ["Ltip_list"],
    }),

    Payrollupdate: builder.mutation({
      query: (data) => {
        return {
          url: API_ENDPOINTS.ASHR.PAYROLL_UPDATE(),
          method: "POST",
          body: data,
          responseHandler: (response) => response.blob(),
        };
      },
      invalidatesTags: ["payroll_list"],
    }),

    getPayrollUpdateButton: builder.query({
      query: ({ pmsYear }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.PAYROLL_UPDATE_BUTTON(pmsYear)}`,
          method: "GET",
        };
      },
      providesTags: ["payroll_list"],
    }),
    getHrButtonhandle: builder.query({
      query: ({ pmsYear }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.HR_BUTTON_HANDLE(pmsYear)}`,
          method: "GET",
        };
      },
      providesTags: ["payroll_list"],
    }),

    getEmpHistory: builder.query({
      query: (empId) => ({
        url: `${API_ENDPOINTS.ASHR.EMP_HISTORY(empId)}`,
        method: "POST",
      }),
      providesTags: ["emp_history"],
    }),
    getEmpTableHistory: builder.query({
      query: (empId) => ({
        url: `${API_ENDPOINTS.ASHR.EMP_TABLE_HISTORY(empId)}`,
        method: "GET",
      }),
      providesTags: ["emp_history"],
    }),

    bhexport: builder.query({
      query: (filterData) => ({
        url: API_ENDPOINTS.PMS.BH_EXPORT(filterData),
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
      extraOptions: { isExport: true },
    }),
    dhexport: builder.query({
      query: (filterData) => ({
        url: API_ENDPOINTS.PMS.DH_EXPORT(filterData),
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
      extraOptions: { isExport: true },
    }),

    getBhchart: builder.query({
      query: (filterData) => ({
        url: `${API_ENDPOINTS.PMS.BH_CHART(filterData)}`,
        method: "GET",
      }),
      providesTags: ["bh_chart"],
    }),

    getPmsbudget: builder.query({
      query: ({ pmsYear, divisionHeadId, reviewerId, repManagerId }) => {
        return {
          url: `${API_ENDPOINTS.PMS.PMS_BUDGET_COUNT(
            pmsYear,
            divisionHeadId,
            reviewerId,
            repManagerId,
          )}`,
          method: "GET",
        };
      },
      providesTags: ["pms_count"],
    }),
    getRatingPercentage: builder.query({
      query: (pmsYear) => {
        console.log("pmsYear in API call:", pmsYear);
        return {
          url: `${API_ENDPOINTS.ASHR.RATING_PERCENTAGE_GET(pmsYear)}`,
          method: "GET",
        };
      },
      providesTags: ["budgetMaster"],
    }),
    updateRatingPercentage: builder.mutation({
      query: (data) => {
        return {
          url: `${API_ENDPOINTS.ASHR.RATING_PERCENTAGE_UPDATE()}`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["budgetMaster"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(DivisionHeadApi.util.invalidateTags(["allocation"]));
        } catch (error) {
          // console.error("withdrawRegularization failed:", error);
        }
      },
    }),

    getHrStatusCount: builder.query({
      query: ({
        pmsYear,
        divisionHeadId,
        reviewerId,
        repManagerId,
        empId,
        status,
        promotion,
      }) => ({
        url: `/pms/getHRStatusCount`,
        method: "POST",
        body: {
          pmsYear,
          divisionHeadId,
          reviewerId,
          repManagerId,
          empId,
          status,
          promotion,
        },
      }),
      providesTags: ["HR_StatusCount"],
    }),

    getHrSummary: builder.query({
      query: (pmsYear) => {
        return {
          url: `${API_ENDPOINTS.ASHR.HR_SUMMARY(pmsYear)}`,
          method: "GET",
        };
      },
      providesTags: ["hr_summary"],
    }),

    CtcSplitup: builder.mutation({
      query: (data) => {
        return {
          url: API_ENDPOINTS.ASHR.CTC_SPLIT_UP(),
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["Ctc_split"],
    }),
    UpdateCurrentCtc: builder.mutation({
      query: (data) => {
        return {
          url: API_ENDPOINTS.ASHR.UPDATE_CTC(data.withEffectDate, data.type),
          method: "POST",
        };
      },
      invalidatesTags: ["update_ctc"],
    }),

    getRevisedCTCList: builder.query({
      query: ({
        level,
        repManId,
        reviewerId,
        divHeadId,
        empId,
        manPower,
        pmsYear,
        roleOfIntake,
        department,
        grade,
        payrollSubmitStatus,
      }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.REVISED_CTC_LIST(
            level,
            repManId,
            reviewerId,
            divHeadId,
            empId,
            manPower,
            pmsYear,
            roleOfIntake,
            department,
            grade,
            payrollSubmitStatus,
          )}`,
          method: "GET",
        };
      },
      providesTags: ["revisedCTC_list"],
    }),
    UpdateRevisedCTCToQC: builder.mutation({
      query: (data) => {
        return {
          url: API_ENDPOINTS.ASHR.UPDATE_REVISEDCTC_TO_QC,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["revisedCTC_list"],
    }),
    fetchOcrList: builder.query({
      query: ({ pmsYear }) => ({
        url: API_ENDPOINTS.OCR.OCR_LIST(pmsYear),
        method: "GET",
      }),
      providesTags: ["ocr_list"],
    }),
    getConversionList: builder.query({
      query: ({ pmsYear, roleOfIntake }) => {
        return {
          url: `${API_ENDPOINTS.ASHR.CONVERSION_LIST(pmsYear, roleOfIntake)}`,
          method: "GET",
        };
      },
      providesTags: ["conversion_list"],
    }),
    hrSampleDownload: builder.mutation({
      query: () => ({
        url: API_ENDPOINTS.ASHR.HR_BH_SAMPLE_DOWNLOAD(),
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetAsHRDropdownQuery,
  useGetAsHRListQuery,
  useCtcBulkUploadMutation,
  useCtcDownloadSampleFileMutation,
  useGetCtcBreakupListQuery,
  useLazyGetCtcBreakupListQuery,
  useGetCtcDropDownQuery,
  useGetPayrollListQuery,
  useLazyGetPayrollListQuery,
  useLazyGetCtcExportQuery,
  useGetOrgListQuery,
  useLazyGetORGLetterPreviewQuery,

  useGetDhAnalyticsReportQuery,
  useGetAnalyticsReportQuery,
  useGetQcListQuery,
  useLazyGetQcListQuery,
  useLazyGetQCLetterPreviewQuery,
  useQCupdateMutation,
  useQcDownloadSampleFileMutation,
  useQcBulkUploadMutation,
  useQcOcrCompareMutation,
  useQcUpdateLetterStatusMutation,
  useUpdateAsHRMutation,
  useSendOrgMailMutation,

  useLazyGetOrgListQuery,

  useLazyGetSampleDownloadQuery,
  useLazyGetAsHRListQuery,
  useAsHRBulkUploadMutation,

  useLtipDownloadSampleFileMutation,
  useGetLtipListQuery,
  useLazyGetLtipListQuery,
  useLazyGetLtipLetterPreviewQuery,
  useLtipBulkUploadMutation,
  useLtipupdateMutation,
  useGetLtipDropdownQuery,
  usePayrollupdateMutation,
  useGetPayrollUpdateButtonQuery,
  useGetHrButtonhandleQuery,

  useGetEmpHistoryQuery,
  useBhexportQuery,
  useLazyBhexportQuery,
  useLazyDhexportQuery,
  useGetBhchartQuery,
  useGetPmsbudgetQuery,
  useGetRatingPercentageQuery,
  useUpdateRatingPercentageMutation,
  useGetEmpTableHistoryQuery,
  useGetHrStatusCountQuery,
  useGetHrSummaryQuery,
  useCtcSplitupMutation,
  useUpdateCurrentCtcMutation,

  useManpowerBulkUploadMutation,
  useGetRevisedCTCListQuery,
  useUpdateRevisedCTCToQCMutation,
  useGetConversionListQuery,
  useFetchOcrListQuery,
  useLazyFetchOcrListQuery,
  useOcrBulkUploadMutation,
  useOcrUpdateMutation,
  useGetManpowerListQuery,
  useHrSampleDownloadMutation,
  useGetOrgCountQuery,
  useSendManualMailMutation,
  useGetManpowerDropdownQuery,
  useGetOrgpendingQuery,
  useOrgManualUploadMutation,
} = AsHRApi;
